<template>
	<div>
		<ModalSearchRegistration ref="modalSearchRegistration" @action="cari"></ModalSearchRegistration>
		<v-card class="pa-4 elevation-0 rounded-lg">
			<v-row>
				<v-col cols="12" class="text-right">
					<v-btn depressed color="primary" class="white--text rounded-lg text-capitalize" @click="showSearch">Cari</v-btn>
					<v-btn depressed color="grey lighten-1" class="ml-3 white--text rounded-lg text-capitalize" @click="reset">Reset</v-btn>
				</v-col>
			</v-row>
			<div class="mt-3" v-if="!loading">
				<v-row class="ml-0" v-if="listSerialMembership.length > 0">
					<v-col cols="12" sm="6" md="4" xl="3" class="pl-0 pt-0" v-for="(serial, i) in listSerialMembership" :key="i">
						<v-card outlined class="pa-3 elevation-0 rounded-lg hover-shadow">
							<v-row>
								<v-col cols="12" class="pb-0">
									<div class="font-size-10 cl-grey">Serial</div>
									<div class="font-size-11 cl-primary font-weight-500">{{ serial.serial_transfer_log_serial_id }}</div>
								</v-col>
								<v-col md="6" class="pt-2">
									<div class="font-size-10 cl-grey">Status</div>
									<div class="font-size-10 cl-grey font-weight-500 text-capitalize">
										<div class="red--text" v-if="serial.serial_transfer_log_status == 'keluar'">{{ serial.serial_transfer_log_status }}</div>
										<div class="green--text" v-else>{{ serial.serial_transfer_log_status }}</div>
									</div>
								</v-col>
								<v-col md="6" class="pt-2">
									<div class="font-size-10 cl-grey">Tanggal Transfer</div>
									<div class="font-size-10 cl-grey font-weight-500">{{ serial.serial_transfer_log_serial_buy_datetime | tanggal }}</div>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
				<div v-if="listSerialMembership.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="pt-3 elevation-0 rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data serial yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-3" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</v-card>
		<div class="mt-3" v-if="listSerialMembership.length > 0">
			<v-row justify="end">
				<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
					<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="serialMembershipPagination.total_page" @input="changePage"></v-pagination>
				</v-col>
				<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
					<div class=" font-size-10">Menampilkan {{ serialMembershipPagination.total_display }} data dari total {{ serialMembershipPagination.total_data }} data</div>
				</v-col>
				<v-col cols="4" sm="2" md="1">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSearchRegistration from './components/ModalSearchRegistration';

export default {
	components: {
		ModalSearchRegistration
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '12',
			listLimit: [ '12', '20', '50', '100' ],
			params: [],
		}
	},
	computed: {
		...mapState('historySerial', ['listSerialMembership', 'serialMembershipPagination']),
	},
	methods: {
		...mapActions('historySerial', ['getHistoryTransferMembership']),

		showSearch() {
			this.$refs.modalSearchRegistration.modalShow()
		},
		cari(data) {
			this.params = []
			this.page = 1

			if(data.serial.value)
				this.params.push(data.serial)

			if(data.status.value)
				this.params.push(data.status)

			if(data.dateTransfer.value)
				this.params.push(data.dateTransfer)

			this.getHistoryTransferMembership(this.queryString({limit:this.limit, page: this.page, params: this.params})).then(() => {
				this.$refs.modalSearchRegistration.modalHide()
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		reset() {
			this.page = 1
			this.limit = '12'
			this.params = []
			this.getData()
			this.$refs.modalSearchRegistration.reset()
		},
		getData() {
			this.loading = true
			this.getHistoryTransferMembership(this.queryString({limit:this.limit, page: this.page, params: this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},
	},
	created(){
		this.getData()
	}
};
</script>

